export default __webpack_public_path__ + "static/media/NunitoSans-VariableFont.61b71ee9.ttf";